<template>

  <v-container fluid class="pa-0">

    <app-sign-device-private-key-reader :certificateAuthority="certificateAuthority" :disabled="disabled" :eventBus="eventBus"
      :privateKeyType="privateKeyType" :signMethod="signMethod" :useUserCertificates="useUserCertificates"
      :should-validate-key-type="shouldValidateKeyType" @keyReaded="onSignKeyReaded" @ready="onReady" @not-ready="onNotReady">
    </app-sign-device-private-key-reader>

  </v-container>

</template>

<script>
import AppSignBaseTab from './AppSignBaseTab';
import AppSignDevicePrivateKeyReader from './AppSignDevicePrivateKeyReader';
import { SignMethod } from '@/sign/models/sign-constants';

export default {
  name: 'AppSignDeviceTab',
  extends: AppSignBaseTab,
  components: { AppSignDevicePrivateKeyReader },
  data() {
    return { signMethod: SignMethod.Device };
  },
  computed: {
    signingParamsRequestChildMsg() {
      return `${this.signingParamsRequestMsg}-DeviceSelector`;
    },
    signingParamsResponseChildMsg() {
      return `${this.signingParamsResponseMsg}-DeviceSelector`;
    }
  }
};
</script>
